exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/prod/mcFrontend2/src/components/popup/cloud_transfer_popups/task_single_popup.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CACpB","file":"task_single_popup.vue","sourcesContent":[".el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61d6b8ae","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/cloud_transfer_popups/task_single_popup.vue
// module id = whQX
// module chunks = 1